import './home2.css';
import React from 'react';

const Home2 = () => {
  return (
    <div>
      <section className="hero2">
        <div className="container herooadding" style={{paddingInline: "5px"}}>
          <div className="row">
            <div className="col-lg-12">
            <div className='d-flex'>
            <h1>الموقع الشخصي لأحمد زعـــكان</h1>
            <p>مرحبًا، أنا أحمد زعـــكان، مطور مواقع ويب محترف. أعمل على تحويل الأفكار المبدعة إلى مواقع إلكترونية متميزة وعملية. باستخدام أحدث التقنيات والأدوات، أضمن بإذن الله تقديم تجارب مستخدم مذهلة وتصميمات متجاوبة تلبي احتياجات العملاء.</p>
            </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home2;
